import fileDownload from "js-file-download";
import { message } from 'antd';

import axios from 'util/axiosConfig';


// export const getAllHL7OutMessages = async (endDate, startDate) => {
//     return await axios.get(`/api/v1/admin/hl7-out-messages`, {
//         params: {
//             endDate: endDate,
//             startDate: startDate
//         }
//     })
//         .then(function (response) {
//             if (response.data) {
//                 return { success: true, data: response.data };
//             } else {
//                 return { success: false };
//             }
//         })
//         .catch(function (error) {
//             return { success: false, error };
//         });
// }

export const getAllHL7SentMessages = async (params) => {
    let modifiedParams = {
        ...params,
        page: params.page - 1
    };
    // Omit null/undefined date filters - backend treats missing as "no date filter"
    if (modifiedParams.startDate == null || modifiedParams.endDate == null) {
        delete modifiedParams.startDate;
        delete modifiedParams.endDate;
    }
    return await axios.post(`/api/v1/admin/hl7-sent`, modifiedParams)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}
export const getHL7OutMessage = async (messageControlId) => {
    return await axios.get(`/api/v1/admin/hl7-sent-message`, {
        params: {
            messageControlId
        }
    })
        .then(function (response) {
            if (response.status === 200) {
                const fileName = messageControlId + '.hl7';
                fileDownload(response.data, fileName);
            } else {
                message.error('Failed to download file!');
            }
        })
        .catch(function (error) {
            message.error('Failed to download file!');
        });
}

export const resendHL7SentMessageAPI = async (messageControlId) => {
    return await axios.get(`/api/v1/admin/resend-hl7-sent-message`, {
        params: {
            messageControlId
        }
    })
        .then(function (response) {
            if (response.status === 200) {
                return response.data;
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}